var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2861,
    y: 14.2856,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.14258,
    y: 14.2856,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 14.2856,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2861,
    y: 7.14307,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.14258,
    y: 7.14307,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 7.14307,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2861,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.14258,
    width: 5.71429,
    height: 5.71429,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/Modules.c848f11ac95ec0657fd8a1c72decd6d8.svg";
export { ForwardRef as ReactComponent };